export default [
  {
    bugfix: 0, // 0 or 1
    date: "7-14-2022",
    version: "REPORTS",
    location: "web",
    title: "Reports Added",
    details: "Ethnicity - All services stats - Gender - All services stats - Residents With Disabilities stats - ",
  },
  {
    bugfix: 0, // 0 or 1
    date: "7-13-2022",
    version: "REPORTS",
    location: "web",
    title: "Reports Added",
    details: "Client Program Stats - Gender - Ethnicity - Identified Sexual Orientation - Limited English Proficiency - With Disabilities - ",
  },
  {
    bugfix: 0, // 0 or 1
    date: "7-12-2022",
    version: "REPORTS",
    location: "web",
    title: "Reports Added",
    details: "Dashboard Stats added date search - Client Program Stats - Admitted Clients - Discharge Date 3 & 30 Days Approved Stats - ",
  },
  {
    bugfix: 0, // 0 or 1
    date: "7-11-2022",
    version: "REPORTS",
    location: "web",
    title: "Reports Added",
    details: "Client Program Stats - Admitted Clients - Discharge Date 3 & 30 Days Approved Stats - Referral Outcome - Current & Discharged Clients Average Length Of Stay - Current & Discharge Clients Average Age - ",
  },
  {
    bugfix: 1, // 0 or 1
    date: "7-09-2022",
    version: "FE",
    location: "web",
    title: "Client Change Program Confirm Prompt Added",
    details: "Added Ok Cancel when changing a Clients program to confirm you want to change program before completing the change.",
  },
  {
    bugfix: 1, // 0 or 1
    date: "7-10-2022",
    version: "FE",
    location: "web",
    title: "Login Edit Screen Reset Password Settings Updated",
    details: "Added Reset Password to the edit login page.  Added auto generated passwords.  The auto generated password is provided on the Login Edit screen.",
  },
  {
    bugfix: 1, // 0 or 1
    date: "7-07-2022",
    version: "FE",
    location: "web",
    title: "Login Addd / Register Screen Password Settings Updated",
    details: "Added auto generated passwords.  The auto generated password is provided on screen.",
  },
  {
    bugfix: 0, // 0 or 1
    date: "7-06-2022",
    version: "FE",
    location: "web",
    title: "Dates tab updated",
    details: "Consolidated dates tab providing 1 location to view all dates - ",
  },
  {
    bugfix: 1, // 0 or 1
    date: "6-21-2022",
    version: "FE",
    location: "web",
    title: "Add new Login issue resolved",
    details: "Add new Login issue resolved -- Updated Login experience error trapping",
  },
  {
    bugfix: 1, // 0 or 1
    date: "11-6-2021",
    version: "FE",
    location: "web",
    title: "New fields for phone and emergency contact",
    details: "New fields for phone and emergency contact",
  },
  {
    bugfix: 1, // 0 or 1
    date: "11-5-2021",
    version: "REPORTS",
    location: "web",
    title: "New Annual Reports Added",
    details: "New Annual Reports Added",
  },
  {
    bugfix: 0, // 0 or 1
    date: "10-4-2021",
    version: "FE",
    location: "web",
    title: "Virtual Server Instance Updates",
    details: "Virtual Server Instance Updates",
  },
  {
    bugfix: 1, // 0 or 1
    date: "10-4-2021",
    version: "FE",
    location: "web",
    title: "Fixed Post Discharge Sub groups not loading issue",
    details: "Fixed if user clicked post discharge 12 month, 24 month, etc user receives the following error message. 'You have no programs to show. Please get with your admin to give you program access.' ",
  },
  {
    bugfix: 1, // 0 or 1
    date: "10-4-2021",
    version: "FE",
    location: "web",
    title: "Fixed Change Log not updating issue on referrals",
    details: "Fixed Change Log not updating issue on referrals",
  },
  {
    bugfix: 1, // 0 or 1
    date: "10-3-2021",
    version: "FE",
    location: "web",
    title: "MIGRATE PHYSICAL SERVER TO NEW VIRTUAL SERVER",
    details: "MIGRATE PHYSICAL SERVER TO NEW VIRTUAL SERVER",
  },
  {
    bugfix: 1, // 0 or 1
    date: "4-5-2021",
    version: "FE",
    location: "web",
    title: "Change Log link added",
    details: "Change Log link added",
  },

];
